import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';

// API
import { queryClient } from './api/queryClient';

// Theme
import theme from '../../../theme';

// Components
// TODO: Patch the design system to export this in index.js
import ErrorBoundary from '../../components/ErrorBoundary';
import AuthManager from '../../components/AuthManager';

import App from './manager';

/**
 * Add Sentry for React
 * Replace this when CAT-RCKMS is fully React driven
 */

Sentry.init({
    dsn: process.env.SENTRY_DSN || undefined,
    environment: process.env.SENTRY_ENVIRONMENT || undefined,
    release: process.env.SENTRY_RELEASE || undefined
});

Sentry.setContext('rckms_module', {
    name: 'Criteria Resource Manager'
});

const MountedApp = ({ ...props }) => (
    <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
            <AuthManager {...props}>
                {({ userContext }) => (
                    <ErrorBoundary>
                        <App userContext={userContext} />
                    </ErrorBoundary>
                )}
            </AuthManager>
        </QueryClientProvider>
    </ThemeProvider>
);

render(<MountedApp />, document.getElementById('catPf'));
